<template>
  <div>
    
    <memlist-card v-if="!local_item">
      <div class="mx-auto d-flex justify-content-center mb-3">
        <memlist-spinner />
      </div>
    </memlist-card>

    <memlist-card>
      <!-- add a round heart button/favorit -->

      <memlist-text-input
        id="name"
        name="name"
        :title="$t('SALES.CONTACT_NAME')"
        layout="vertical"
        v-model="local_item.name"
      />

      <memlist-text-input
        id="title"
        name="title"
        :title="$t('SALES.CONTACT_TITLE')"
        layout="vertical"
        v-model="local_item.title"
      />

      <div class="stats-row" style="margin-top: 8px;">
        
        <div class="call-and-edit">
          <memlist-text-input
            style="margin-top: 0px;"
            @blur="on_blur"
            :placeholder="$t('SALES.PHONE1')"
            ref="phone1-input"
            id="phone1"
            name="phone1"
            layout="vertical"
            v-model="local_item.phone1"
          />
          <a
            style="width: 44px; height: 37px;"
            href="#"
            class="btn btn-outline-primary font-weight-bolder font-size-sm small-button"
            @click.prevent="call_clicked(local_item.phone1)"
            >
              <i class="mdi mdi-phone call-button-icon" aria-hidden="true"></i>
          </a>
          
        </div>
        
      </div>
      <div class="stats-row">
        
        <div class="call-and-edit">
          <memlist-text-input
            style="margin-top: 0px;"
            @blur="on_blur"
            :placeholder="$t('SALES.PHONE2')"
            ref="phone2-input"
            id="phone2"
            name="phone2"
            layout="vertical"
            v-model="local_item.phone2"
          />
          <a
            style="width: 44px; height: 37px;"
            href="#"
            class="btn btn-outline-primary font-weight-bolder font-size-sm small-button"
            @click.prevent="call_clicked(local_item.phone2)"
            >
              <i class="mdi mdi-phone call-button-icon" aria-hidden="true"></i>
          </a>
          
        </div>

      </div>

      <div class="stats-row">
        <div class="call-and-edit">
          <memlist-text-input
            style=" margin-top: 0px;"
            @blur="on_blur"
            :placeholder="$t('SALES.EMAIL1')"
            ref="email1-input"
            id="email1"
            name="email1"
            layout="vertical"
            v-model="local_item.email1"
          />
          <a
            style="width: 44px; height: 37px;"
            href="#"
            class="btn btn-outline-primary font-weight-bolder font-size-sm small-button"
            @click.prevent="email_clicked(local_item.email1)"
            >
              <i class="mdi mdi-email-fast-outline call-button-icon" aria-hidden="true"></i>
          </a>
          
        </div>

      </div>

      <div class="stats-row">
        <div class="call-and-edit">
          <memlist-text-input
            style="margin-top: 0px;"
            @blur="on_blur"
            :placeholder="$t('SALES.EMAIL2')"
            ref="email2-input"
            id="email2"
            name="email2"
            layout="vertical"
            v-model="local_item.email2"
          />
          <a
            style="width: 44px; height: 37px;"
            href="#"
            class="btn btn-outline-primary font-weight-bolder font-size-sm small-button"
            @click.prevent="email_clicked(local_item.email2)"
            >
              <i class="mdi mdi-email-fast-outline call-button-icon" aria-hidden="true"></i>
          </a>
          
        </div>

      </div>

      <memlist-icon-button
        v-if="local_item.id"  
        class="mb-2 mt-4"
        icon="menu-icon flaticon2-trash"
        :text="$t('COMMON.DELETE')"
        variant="danger"
        @click="delete_clicked"
      />

    
    </memlist-card>
  </div>
    
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import {
  SET_USER_PREFS
} from '@/core/services/store/common.module';
import store from '@/core/services/store';
import { validate_email } from '@/core/services/email';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'SalesContactPerson',
  components: {

  },
  mixins: [ toasts ],

  props: ['contact','prospect'],
  data() {
    return {
      local_item: {},
      editing_name: false,
      editing_phone1: false,
      editing_phone2: false,
      editing_email1: false,
      editing_email2: false,
      refresh: 0,
      interval_id: null,
      showSearchPopup: false,
      showContactPopup: false,
      searchResults: [
        // Example data, replace with dynamic results
        { url: 'https://example.com', description: 'Example website' },
        { url: 'https://another.com', description: 'Another website' },
      ],
      contactResults: [
        // Example data, replace with dynamic results
        { title: 'Manager', name: 'John Doe', phone: '123-456-7890', email: 'john.doe@example.com' },
        { title: 'Assistant', name: 'Jane Smith', phone: '987-654-3210', email: 'jane.smith@example.com' },
      ],
    };
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId','isAuthenticated','initComplete','user_prefs']),
    
    style_email1() {
      this.refresh;

      if (!this.contact.email1) {
        return {
          'border-color': 'black',
          'color': 'black'
        }
      }

      if (!validate_email(this.contact.email1)) {
        return {
          'border-color': 'rgb(255, 68, 68)',
          'color': 'rgb(255, 68, 68)'
        }
      }

    },

    style_email2() {
      this.refresh;

      if (!this.contact.email2) {
        return {
          'border-color': 'black',
          'color': 'black'
        }
      }

      if (!validate_email(this.contact.email2)) {
        return {
          'border-color': 'rgb(255, 68, 68)',
          'color': 'rgb(255, 68, 68)'
        }
      }

    },

    style_phone1() {
      this.refresh;

      if (!this.contact.phone1) {
        return {
          'border-color': 'black',
          'color': 'black'
        }
      }

    },

    style_phone2() {
      this.refresh;

      if (!this.contact.phone2) {
        return {
          'border-color': 'black',
          'color': 'black'
        }
      }

    },

    style_contacts() {
      this.refresh;

      switch (this.contact.openai_status) {
        case 'NONE':
        case 'STARTED':
          return {
            'border-color': 'gray',
            'color': 'gray'
          }
        case 'FAILED':
          return {
            'border-color': 'rgb(255, 68, 68)',
            'color': 'rgb(255, 68, 68)'
          }
        case 'ENDED': {
          return {}
        }
      }

      return {
        'border-color': 'white'
      }
    },

    style_websites() {
      this.refresh;

      switch (this.contact.search_status) {
        case 'NONE':
        case 'STARTED':
          return {
            'border-color': 'gray',
            'color': 'gray',
          }
        case 'FAILED':
          return {
            'border-color': 'red',
            'color': 'red'
          }
        case 'ENDED': {
          return {}
        }
      }

      return {
        'border-color': 'white'
      }
    },

    status_class() {
      return '';
    },
    
  },
  mounted() {

    if (this.interval_id) {
      return;
    }

    this.interval_id = setInterval(() => {
      this.refresh++;
    }, 1000);

  },
  watch: {
    currentCompanyId() {
      
    },
    currentPeriodId(newValue, oldValue) {
    
    },
    contact: {
      handler(newVal) {

        if (this.contact) {
          this.local_item = { ...this.contact };

          if (this.contact.id) {
            
          }
        }
        
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {

    async delete_clicked() {
      const res = await axios.delete(`/sales/contact/${this.local_item.id}`);

      if (res.status === 200) {
        this.$emit('deleted', this.local_item.id);
      }
      else {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('SALES.UNABLE_DELETE_CONTACT'));
      }
    },

    on_blur() {
      if (!this.local_item.id) {
        return;
      }

      this.save();
    },

    async save() {
      
      if (this.local_item.id) {
        await this.update_contact();
      }
      else {
        await this.create_contact();
      }
    },

    async update_contact() {
      const res = await axios.put(`/sales/contact/${this.local_item.id}`, this.local_item);

      if (res.status === 204) {
        this.$emit('updated', this.local_item);
      }
      else {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('SALES.UNABLE_CONTACT_UPDATE'));
      }
    },

    async create_contact() {
      const res = await axios.post(`/sales/${this.prospect.id}/contact`, this.local_item);

      if (res.status === 201) {
        this.local_item = { ...res.data };
        console.log('emitting created', this.local_item)
        this.$emit('created', this.local_item);
      }
      else {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('SALES.UNABLE_CONTACT_CREATE'));
      }
    },

    email_clicked(email) {
      if (email) {
        // open email client and populate email
        // or use our own template sendout
      }
      else {
        // open the editor (input email)
      }
    },

    call_clicked(phone) {
      console.log('call_clicked', phone);

      if (phone) {
        // call
        console.log('emitting', this.contact, phone)
        this.$emit('call_clicked', this.contact, phone);
      }
      
    },

    clicked_contact() {
      this.$emit('click', this.contact);
    },
    calculate_seconds_since() {
      
      if (!this.contact || !dayjs(this.contact.last_polled_at).isValid()) {
        return null
      }

      const now = dayjs();
      const created = dayjs(this.contact.last_polled_at);
      return now.diff(created, 'seconds');
    },
    calculate_minutes_since() {
      if (!this.contact || !dayjs(this.contact.last_polled_at).isValid()) {
        return null
      }

      const now = dayjs();
      const created = dayjs(this.contact.last_polled_at);
      return now.diff(created, 'minutes');
    },
  }
};
</script>

<style lang="scss" scoped>

.call-and-edit {
  display: flex;               /* put input + button on one row   */
  align-items: center;         /* vertically centre them           */
}

/* grow the input so it takes all remaining width */
.call-and-edit memlist-text-input {
  flex: 1 1 auto;
}

/* tiny-button tweaks */
.call-and-edit .small-button {
  width: 34px;                 /* small square (tweak as needed)   */
  height: 34px;
  padding: 0;                  /* let the icon fill the button     */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: .25rem;         /* a little gap from the input      */
  font-size: 0.9rem;           /* keeps mdi icon small             */
}

.stats-row {
  margin-top: 8px;
}
</style>
